export const UPSERT_RECIPIENT_ATTRIBUTES_CONSTANT = {
  sender: {
    type: 'select',
    key: 'sender_id',
    label: 'Sender',
  },
  firstName: {
    type: 'text',
    key: 'bene_first_name',
    label: 'Recipient First Name',
  },
  middleName: {
    type: 'text',
    key: 'bene_middle_name',
    label: 'Recipient Middle Name',
  },
  lastName: {
    type: 'text',
    key: 'bene_last_name',
    label: 'Recipient Last Name',
  },
  dob: {
    type: 'date',
    key: 'bene_date_of_birth',
    label: 'Recipient Date of Birth',
  },
  gender: {
    type: 'select',
    key: 'gender',
    label: 'Gender',
  },
  mobileCode: {
    type: 'text',
    key: 'bene_mobile_code',
  },
  mobileNumber: {
    type: 'tel',
    key: 'bene_mobile_number',
    label: 'Recipient Mobile',
  },
  email: {
    type: 'email',
    key: 'bene_email',
    label: 'Recipient Email',
  },
  beneAddress: {
    type: 'text',
    key: 'bene_address',
    label: 'Recipient Address',
  },
  beneCity: {
    type: 'text',
    key: 'bene_city',
    label: 'Recipient City',
  },
  benePostCode: {
    type: 'text',
    key: 'bene_post_code',
    label: 'Recipient Postal Code',
  },
  beneCountry: {
    type: 'select',
    key: 'benificiary_country',
    label: 'Recipient Country',
  },
  transferType: {
    type: 'select',
    key: 'transfer_type_po',
    label: 'Transfer Type',
  },
  senderBeneRelation: {
    type: 'text',
    key: 'sender_beneficiary_relation',
    label: 'Sender Beneficiary Relation',
  },
  isFavorite: {
    type: 'checkbox',
    key: 'is_favorite',
    label: 'Is Favorite?',
  },
} as const;
